import { render, staticRenderFns } from "./listOfAlliancesCategories.vue?vue&type=template&id=a7252086&scoped=true&"
import script from "./listOfAlliancesCategories.vue?vue&type=script&lang=js&"
export * from "./listOfAlliancesCategories.vue?vue&type=script&lang=js&"
import style0 from "./listOfAlliancesCategories.vue?vue&type=style&index=0&id=a7252086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7252086",
  null
  
)

export default component.exports